// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner-module--banner--3kPS1","footer":"banner-module--footer--3eHTG","footerText":"banner-module--footerText--3EmPC"};